export default __webpack_public_path__ + "static/media/capelo.83a19926.svg";